import type { ComputedRef, InjectionKey } from 'vue'

import type { KControlSize } from '../../types'

export interface KFieldContext {
    controlId: ComputedRef<string>
    labelId: ComputedRef<string | undefined>
    describedBy: ComputedRef<string | undefined>
    invalid: ComputedRef<boolean>
    required: ComputedRef<boolean>
    disabled: ComputedRef<boolean>
    nativeDisabled: ComputedRef<boolean>
    size: ComputedRef<KControlSize>
    registerOwnLabel: () => () => void
}

export const K_FIELD_CONTEXT = Symbol('KField') as InjectionKey<KFieldContext>
